var createBasicObserver = require("../../../common/js/_createBasicObserver");
var createSequentialObserver = require("../../../common/js/_createSequentialObserver");
var createSlideshow = require("../../../common/js/_slideshow");
var editorialCarousel = require("../../../common/js/_editorialCarousel");
var createVideo = require(".../../../common/js/_video");
var lazyloadImages = require("../../../common/js/_lazyloadImages");

document.addEventListener("DOMContentLoaded", () => {

	const isMobile = window.innerWidth < 720;

	// top_banner:
	const TOP_BANNER = "topbanner";
	let slideshow = null;
	createSequentialObserver({
		selector: `.${TOP_BANNER}`,
		thresholdGroups: [
			{
				threshold: 0,
				condition: ">",
				callbacks: [
					() => {
						slideshow = createSlideshow({
							slideshowSelector: `.${TOP_BANNER} .slideshow_wrap`,
							slideSelector: `.${TOP_BANNER} .slideshow_cell`,
							// debug: true, // Debug
						});
						slideshow.init();
					}
				],
			},
			{
				threshold: 0.9,
				callbacks: [
					() => {
						slideshow.startAutoPlay();
					},
				],
			},
		],
		observerConfig: {
			root: null, // Use the viewport as the root
			rootMargin: "50px",
			threshold: 0,
		},
	});

	// editorial carousels:
	const sections = document.querySelectorAll(".section_carousel");
	sections.forEach((section, index) => {
		const carouselEl = section.querySelector(".carousel");
		if (!carouselEl) return;
		// to target different sections:
		const uniqueClass = `carousel-order-${index}`;
		carouselEl.classList.add(uniqueClass);
		const isSmall = section.classList.contains("small");
		createBasicObserver({
			selector: `.${uniqueClass}`,
			callback: () => {
				new editorialCarousel({
					carouselSelector: `.${uniqueClass}`,
					groupCells: isSmall ? 5 : 3,
				}).init();
			},
			config: {
				rootMargin: "50px",
			}
		});
	});


	// video_iconicyear
	const SECTION_VIDEO = "section_video";
	const VIDEO_CONTAINER = "video_iconicyear";
	const desktopSrc = document.querySelector(`.${VIDEO_CONTAINER} video`).dataset.desktopsrc;
	const mobileSrc = document.querySelector(`.${VIDEO_CONTAINER} video`).dataset.mobilesrc || desktopSrc;
	if (!desktopSrc) return;

	createBasicObserver({
		selector: `.${SECTION_VIDEO}`,
		callback: () => {
			lazyloadImages(`.${SECTION_VIDEO} .slideshow_cell`);
			const video = createVideo({
				isPreload: false,
				sectionSelector: `.${SECTION_VIDEO}`,
				videoContainerSelector: `.${VIDEO_CONTAINER}`,
				videoSelector: `.${VIDEO_CONTAINER} video`,
				posterSelector: `.${VIDEO_CONTAINER} .video-poster`,
				desktopSrc: desktopSrc,
				mobileSrc: mobileSrc,
				playBtnSelector: `.${SECTION_VIDEO} .${VIDEO_CONTAINER} .play-btn`,
			});
			video.init();
		},
		config: {
			rootMargin: "50px",
		},
	});

	// sections with lazyload + mobile carousel
	["alsomacys", "needinspo"].forEach((selector) => {
		createBasicObserver({
			selector: `.${selector}`,
			callback: () => {
				lazyloadImages(`.${selector} .card`);
			},
			config: { rootMargin: "50px" },
		});

		if (isMobile) {
			createBasicObserver({
				selector: `.${selector}`,
				callback: () => {
					new editorialCarousel({
						carouselSelector: `.${selector} .grids-inner`,
						groupCells: 3,
					}).init();
				},
				config: { rootMargin: "50px" },
			});
		}
	});

	// doublecolumn: lazyload only
	createBasicObserver({
		selector: `.doublecolumn`,
		callback: () => {
			lazyloadImages(`.doublecolumn .card`);
		},
		config: { rootMargin: "50px" },
	});

	// console.log("new version!");
	// utag tracking: 
	document.querySelectorAll('a[href*="lid=welcometomacys_doublecolumn-backstage"]').forEach((el) => {
		el.addEventListener("click", () => {
			utag.link({
				link_name: "welcometomacys_doublecolumn-backstage",
				event_name: "content link click",
			});
		});
	});
	// utag tracking: 
	document.querySelectorAll('a[href*="lid=welcometomacys_alsoatmacys-wineshop"]').forEach((el) => {
		el.addEventListener("click", () => {
			utag.link({
				link_name: "welcometomacys_alsoatmacys-wineshop",
				event_name: "content link click",
			});
		});
	});
	// utag tracking: 
	document.querySelectorAll('a[href*="lid=welcometomacys_alsoatmacys-purpose"]').forEach((el) => {
		el.addEventListener("click", () => {
			utag.link({
				link_name: "welcometomacys_alsoatmacys-purpose",
				event_name: "content link click",
			});
		});
	});

});
